import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  colors,
  Modal,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { IoMdRadioButtonOn } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdTime } from "react-icons/io";
import { FaBagShopping } from "react-icons/fa6";
import { FaBox } from "react-icons/fa";
import { FaArrowLeftLong } from "react-icons/fa6";
import { axiosInstance } from "../../../axiosInstance";
import { data, Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import NoImageFound from "../../../assets/images/No-Image-found.png";

const columns = [
  { id: "medicine_id", label: "Medicine ID", minWidth: 170, align: "center" },
  {
    id: "medicine_name",
    label: "Medicine Name",
    minWidth: 170,
    align: "center",
  },
  { id: "quantity", label: "Quantity", minWidth: 170, align: "center" },
];

function createData(medicine_id, medicine_name, quantity) {
  return {
    medicine_id,
    medicine_name,
    quantity,
  };
}

const packagecolumns = [
  { id: "type_of_pack", label: "Package Type", minWidth: 170, align: "center" },
  {
    id: "no_of_pack",
    label: "No. of Packs",
    minWidth: 170,
    align: "center",
  },
  {
    id: "size_l",
    label: "Size In Length",
    minWidth: 170,
    align: "center",
  },
  {
    id: "size_w",
    label: "Size In Width",
    minWidth: 170,
    align: "center",
  },
  {
    id: "size_h",
    label: "Size In Height",
    minWidth: 170,
    align: "center",
  },
  { id: "weight", label: "Weight", minWidth: 170, align: "center" },
];

function createDataPackage(
  type_of_pack,
  no_of_pack,
  size_l,
  size_w,
  size_h,
  weight,
) {
  return { type_of_pack, no_of_pack, size_l, size_w, size_h, weight };
}

const transactionColumns = [
  { id: "payment_id", label: "Payment ID", minWidth: 170, align: "center" },
  {
    id: "transaction_type",
    label: "Transaction Type",
    minWidth: 170,
    align: "center",
  },
  {
    id: "invoice_amount",
    label: "Invoice Amount",
    minWidth: 170,
    align: "center",
  },
  {
    id: "convience_fee",
    label: "Convenience Fee",
    minWidth: 170,
    align: "center",
  },
  { id: "paid_by", label: "Paid by", minWidth: 170, align: "center" },
];

function createDataTransaction(
  payment_id,
  transaction_type,
  invoice_amount,
  convience_fee,
  paid_by,
) {
  return {
    payment_id,
    transaction_type,
    invoice_amount,
    convience_fee,
    paid_by,
  };
}

const deliveriesDetailescolumns = [
  { id: "delivery_id", label: "DELIVERY ID", minWidth: 170, align: "center" },
  { id: "ryder_id", label: "RYDER ID", minWidth: 170, align: "center" },
  {
    id: "pick_up_location",
    label: "PICKUPLOCATION",
    minWidth: 200,
    align: "center",
  },
  {
    id: "drop_location",
    label: "DROP LOCATION",
    minWidth: 170,
    align: "center",
  },
  {
    id: "delivered_time",
    label: "DELIVERY SLOT TIME",
    minWidth: 170,
    align: "center",
  },
  { id: "no_of_pack", label: "NO OF PACKS", minWidth: 130, align: "center" },
];

function createDataDeliveriesDetailes(
  delivery_id,
  ryder_id,
  pick_up_location,
  drop_location,
  delivered_time,
  no_of_pack,
) {
  return {
    delivery_id,
    ryder_id,
    pick_up_location,
    drop_location,
    delivered_time,
    no_of_pack,
  };
}

const ryderdetailescolumns = [
  {
    id: "profile_picture",
    label: "PROFILE PICTURE",
    minWidth: 120,
    align: "center",
  },
  { id: "username", label: "USERNAME", minWidth: 120, align: "center" },
  { id: "delivery_id", label: "DELIVERY ID", minWidth: 120, align: "center" },
  {
    id: "name",
    label: "NAME",
    minWidth: 170,
    align: "center",
  },
  {
    id: "email",
    label: "EMAIL",
    minWidth: 170,
    align: "center",
  },
  {
    id: "mobile_no",
    label: "MOBILE NUMBER",
    minWidth: 170,
    align: "center",
  },
  { id: "address", label: "ADDRESS", minWidth: 170, align: "center" },
];

function createDataRyderdetailes(
  profile_picture,
  username,
  delivery_id,
  name,
  email,
  mobile_no,
  address,
) {
  return {
    profile_picture,
    username,
    delivery_id,
    name,
    email,
    mobile_no,
    address,
  };
}

const fardeliveryDetailesColumns = [
  { id: "ryder_id", label: "RYDER ID", minWidth: 170, align: "center" },
  {
    id: "pick_up_location",
    label: "PICK UP LOCATION",
    minWidth: 170,
    align: "center",
  },
  {
    id: "drop_location",
    label: "DROP LOCATION",
    minWidth: 170,
    align: "center",
  },
  {
    id: "name",
    label: "RYDER NANE",
    minWidth: 170,
    align: "center",
  },
];

function createDatafardeliveryDetailes(
  ryder_id,
  pick_up_location,
  drop_location,
  name,
) {
  return {
    ryder_id,
    pick_up_location,
    drop_location,
    name,
  };
}

export function EachRetailerOrder() {
  const { orderitem_id } = useParams();

  const navigate = useNavigate();

  const retailerUserID = localStorage.getItem("retailer_User_ID");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [retailerOrdersHistory, setRetailerOrdersHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const invoices = retailerOrdersHistory?.invoice || [];
  const medicines = retailerOrdersHistory?.medicines || [];
  const packages = retailerOrdersHistory?.package || [];

  const leftInvoices = [];
  const rightInvoices = [];

  // Split invoices into left and right columns
  invoices.forEach((invoice, index) => {
    if (invoice.file_url) {
      if (index % 2 === 0) {
        leftInvoices.push({ ...invoice, label: `Document ${index + 1}` });
      } else {
        rightInvoices.push({ ...invoice, label: `Document ${index + 1}` });
      }
    }
  });

  // const WholesalerUserId = localStorage.getItem("wholesaler_User_ID") || "";
  // console.log("Wholesaler User ID:", WholesalerUserId);

  const fetchRetailerOrdersHistory = async () => {
    if (!orderitem_id) {
      setRetailerOrdersHistory([]);
      return;
    }

    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        // `/admin/order-history/${orderitem_id}/`
        `/admin/order-detail/${orderitem_id}`,
      );
      console.log("✅ Retailer Orders History List response:", res.data);
      if (res.data.status === "success") {
        setRetailerOrdersHistory(res.data.data || []);
      } else {
        setError("Failed to fetch Retailer Orders History data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Retailer  Orders History data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRetailerOrdersHistory();
  }, []);

  // Ryder rows
  const ryderRows =
    retailerOrdersHistory?.ryder?.map((d) => {
      return {
        profile_picture: d.profile_picture,
        username: d.username,
        delivery_id:
          retailerOrdersHistory?.delivery?.[0]?.delivery_show_id || "--",
        name: `${d.first_name || ""} ${d.last_name || ""}`.trim(),
        email: d.email,
        mobile_no: d.mobile_no,
        address: `${d.door_no || ""}, ${d.street || ""}, ${d.area || ""}, ${
          d.city || ""
        }, ${d.state || ""}, ${d.pincode || ""}`,
      };
    }) || [];

  // far Deliveries rows
  const farDeliveryRows =
    retailerOrdersHistory?.far_delivery_details?.map((d) => {
      return {
        ryder_id: d?.delivery_details?.ryder_id || "-",
        pick_up_location: d?.delivery_details?.pick_up_location || "-",
        drop_location: d?.delivery_details?.drop_location || "-",
        name: d?.ryder_details?.name || "-",
      };
    }) || [];

  // Deliveries rows
  const deliveryRows =
    retailerOrdersHistory?.delivery?.map((d) => {
      return {
        delivery_id: d.delivery_show_id,
        ryder_id: d.ryder_id,
        pick_up_location: d.pick_up_location,
        drop_location: d.drop_location,
        delivered_time: d.delivered_time,
        no_of_pack: retailerOrdersHistory?.package?.[0]?.no_of_pack || "-",
      };
    }) || [];

  // transactions
  const transactionRows =
    retailerOrdersHistory?.transaction?.map((d) => {
      return {
        payment_id: d.payment_id,
        transaction_type: d.transaction_type,
        invoice_amount: d.invoice_amount,
        convience_fee: d.convience_fee,
        paid_by: d.paid_by,
      };
    }) || [];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  console.log(retailerOrdersHistory);

  function formatDateTime(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);

    // Extract parts
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should become 12

    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  }

  const isPdf =
    typeof selectedImage === "string" &&
    selectedImage.toLowerCase().endsWith(".pdf");

  // Append parameters to hide toolbar (editor)
  const pdfUrl = isPdf
    ? `${selectedImage}#toolbar=0&navpanes=0`
    : selectedImage;

  return (
    <>
      <div>
        <div className="arrowNavigation">
          <FaArrowLeftLong
            style={{ cursor: "pointer" }}
            // onClick={() => navigate("/manage-retailer-edit")}
            onClick={() => navigate(`/manage-retailer-edit/${retailerUserID}`)}
          />
          <div>Order Detail:</div>
          <div>{""}</div>
        </div>
        {/* medicne table  */}
        <div>
          <div className="admin-listText mb-2">Medicine Details</div>

          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : medicines.length > 0 ? (
                    medicines
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#E7F0F9" : "white",
                          }}
                        >
                          {columns.map((column) => {
                            let value = row[column.id];
                            if (column.id === "quantity") {
                              value = `${row.quantity} (${row.dispatched_units})`;
                            }
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                className={`${column.id}-column tableCelldata`}
                                sx={{ cursor: "pointer" }}
                              >
                                {value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={columns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
              component="div"
              count={medicines.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
        {/* package details table  */}
        <div>
          <div className="admin-listText my-3">Package Details</div>

          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {packagecolumns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={packagecolumns.length} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : packages.length > 0 ? (
                    packages
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#E7F0F9" : "white",
                          }}
                        >
                          {packagecolumns.map((column) => {
                            const value = row[column.id] || "-";
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                className={`${column.id}-column tableCelldata`}
                              >
                                {value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={packagecolumns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
              component="div"
              count={packages.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>

        {/* invoice details  */}
        <div>
          <div className="admin-listText my-3">Invoice Details</div>

          {invoices.length === 0 ? (
            <div
              style={{ textAlign: "center", padding: "20px", color: "#888" }}
            >
              No invoice details available
            </div>
          ) : (
            <div className="general-container">
              <div className="general-left">
                {leftInvoices.map((invoice, index) => (
                  <div
                    key={`left-${index}`}
                    className="editWholesaler-field"
                    style={{ marginBottom: "16px" }}
                  >
                    <label>{invoice.label}</label>
                    <div>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setSelectedImage(invoice.file_url);
                          setOpenModal(true);
                        }}
                      >
                        {invoice.label}
                      </Button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="general-right">
                {rightInvoices.map((invoice, index) => (
                  <div
                    key={`right-${index}`}
                    className="editWholesaler-field"
                    style={{ marginBottom: "16px" }}
                  >
                    <label>{invoice.label}</label>
                    <div>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setSelectedImage(invoice.file_url);
                          setOpenModal(true);
                        }}
                      >
                        {invoice.label}
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Ryder details  */}
        {retailerOrdersHistory.delivery_type !== "far_delivery" && (
          <div>
            <div className="admin-listText my-3">Ryder Details</div>

            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <Box sx={{ width: "100%", overflowX: "auto" }}>
                <TableContainer
                  sx={{
                    maxHeight: 640,
                    minWidth: 1800,
                    overflowX: "auto",
                  }}
                  className="Table-container"
                >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {ryderdetailescolumns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                            className="table-header"
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell
                            colSpan={ryderdetailescolumns.length}
                            align="center"
                          >
                            <CircularProgress />
                          </TableCell>
                        </TableRow>
                      ) : ryderRows.length > 0 ? (
                        ryderRows
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage,
                          )
                          .map((row, index) => (
                            <TableRow
                              key={index}
                              hover
                              sx={{
                                backgroundColor:
                                  index % 2 === 1 ? "#E7F0F9" : "white",
                              }}
                            >
                              {ryderdetailescolumns.map((column) => {
                                const value = row[column.id];
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    className={`${column.id}-column tableCelldata`}
                                  >
                                    {/* 👉 Custom rendering for special columns */}
                                    {column.id === "profile_picture" ? (
                                      <img
                                        src={value || NoImageFound}
                                        alt="Profile"
                                        style={{
                                          width: 55,
                                          height: 55,
                                          borderRadius: "50%",
                                          objectFit: "cover",
                                        }}
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = NoImageFound;
                                        }}
                                      />
                                    ) : column.id === "address" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "flex-start",
                                          gap: "8px",
                                          maxWidth: "250px",
                                          whiteSpace: "normal",
                                          wordBreak: "break-word",
                                          lineHeight: "1.4",
                                        }}
                                      >
                                        <FaLocationDot
                                          style={{
                                            fontSize: "18px",
                                            color: "#F52D56",
                                            flexShrink: 0,
                                            marginTop: "2px",
                                          }}
                                        />
                                        <span>{value || "-"}</span>
                                      </div>
                                    ) : (
                                      value || "-"
                                    )}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={ryderdetailescolumns.length}
                            align="center"
                            style={{ padding: "40px 0" }}
                          >
                            No Data Available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <TablePagination
                rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
                component="div"
                count={ryderRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        )}

        {/* Deliveries details  */}
        {retailerOrdersHistory.delivery_type !== "far_delivery" && (
          <div>
            <div className="admin-listText my-3">Deliveries Details</div>

            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <Box sx={{ width: "100%", overflowX: "auto" }}>
                <TableContainer
                  sx={{
                    maxHeight: 640,
                    minWidth: 1800,
                    overflowX: "auto",
                  }}
                  className="Table-container"
                >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {deliveriesDetailescolumns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                            className="table-header"
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell
                            colSpan={deliveriesDetailescolumns.length}
                            align="center"
                          >
                            <CircularProgress />
                          </TableCell>
                        </TableRow>
                      ) : deliveryRows.length > 0 ? (
                        deliveryRows
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage,
                          )
                          .map((row, index) => (
                            <TableRow
                              key={index}
                              hover
                              sx={{
                                backgroundColor:
                                  index % 2 === 1 ? "#E7F0F9" : "white",
                              }}
                            >
                              {deliveriesDetailescolumns.map((column) => {
                                const value = row[column.id];
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    className={`${column.id}-column tableCelldata`}
                                  >
                                    {/* 👉 Styled cell rendering */}
                                    {column.id === "pick_up_location" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <IoMdRadioButtonOn
                                          style={{
                                            fontSize: "18px",
                                            color: "#34C759",
                                          }}
                                        />
                                        {value}
                                      </div>
                                    ) : column.id === "drop_location" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <FaLocationDot
                                          style={{
                                            fontSize: "18px",
                                            color: "#F52D56",
                                          }}
                                        />
                                        {value}
                                      </div>
                                    ) : column.id === "delivered_time" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <IoMdTime
                                          style={{
                                            fontSize: "18px",
                                            color: "#FF961F",
                                          }}
                                        />
                                        <span
                                          style={{
                                            border:
                                              "1px solid rgb(168, 199, 231)",
                                            padding: "5px 8px",
                                            borderRadius: "5px",
                                            fontSize: "14px",
                                            background: "#F4F8FC",
                                          }}
                                        >
                                          {formatDateTime(value) || "--"}
                                        </span>
                                      </div>
                                    ) : column.id === "typeofpack" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        {value === "Bag" ? (
                                          <FaBagShopping
                                            style={{
                                              fontSize: "18px",
                                              color: "#FF961F",
                                            }}
                                          />
                                        ) : (
                                          <FaBox
                                            style={{
                                              fontSize: "18px",
                                              color: "#FF961F",
                                            }}
                                          />
                                        )}
                                        {value}
                                      </div>
                                    ) : (
                                      value || "-"
                                    )}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={deliveriesDetailescolumns.length}
                            align="center"
                            style={{ padding: "40px 0" }}
                          >
                            No Data Available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <TablePagination
                rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
                component="div"
                count={deliveryRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        )}

        {/* far Deliveries details  */}
        {retailerOrdersHistory.delivery_type !== "quick_delivery" && (
          <div>
            <div className="admin-listText my-3">Far Delivery Details</div>

            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <Box sx={{ width: "100%", overflowX: "auto" }}>
                <TableContainer
                  sx={{
                    maxHeight: 640,
                    minWidth: 1200,
                    overflowX: "auto",
                  }}
                  className="Table-container"
                >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {fardeliveryDetailesColumns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                            className="table-header"
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell
                            colSpan={fardeliveryDetailesColumns.length}
                            align="center"
                          >
                            <CircularProgress />
                          </TableCell>
                        </TableRow>
                      ) : farDeliveryRows.length > 0 ? (
                        farDeliveryRows
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage,
                          )
                          .map((row, index) => (
                            <TableRow
                              key={index}
                              hover
                              sx={{
                                backgroundColor:
                                  index % 2 === 1 ? "#E7F0F9" : "white",
                              }}
                            >
                              {fardeliveryDetailesColumns.map((column) => {
                                const value = row[column.id];
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    className={`${column.id}-column tableCelldata`}
                                  >
                                    {column.id === "pick_up_location" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "8px",
                                          alignItems: "center",
                                        }}
                                      >
                                        <IoMdRadioButtonOn
                                          style={{
                                            fontSize: "18px",
                                            color: "#34C759",
                                          }}
                                        />
                                        {value}
                                      </div>
                                    ) : column.id === "drop_location" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "8px",
                                          alignItems: "center",
                                        }}
                                      >
                                        <FaLocationDot
                                          style={{
                                            fontSize: "18px",
                                            color: "#F52D56",
                                          }}
                                        />
                                        {value}
                                      </div>
                                    ) : (
                                      value || "-"
                                    )}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={fardeliveryDetailesColumns.length}
                            align="center"
                            style={{ padding: "40px 0" }}
                          >
                            No Far Delivery Details Available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              <TablePagination
                rowsPerPageOptions={[10, 20, 50, 100]}
                component="div"
                count={farDeliveryRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        )}

        {/* transaction details  */}
        <div>
          <div className="admin-listText my-3">Transaction Details</div>

          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {transactionColumns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell
                        colSpan={transactionColumns.length}
                        align="center"
                      >
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : transactionRows.length > 0 ? (
                    transactionRows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row, index) => (
                        <TableRow
                          key={index}
                          hover
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#E7F0F9" : "white",
                          }}
                        >
                          {transactionColumns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                className={`${column.id}-column tableCelldata`}
                              >
                                {value || "--"}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={transactionColumns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
              component="div"
              count={transactionRows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="invoice-image-modal"
        aria-describedby="invoice-image-preview"
      >
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* ❌ Close Button */}
          <button
            onClick={() => setOpenModal(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">Preview the document</h3>
          <hr />
          <div style={{ textAlign: "center" }}>
            {selectedImage ? (
              // <img
              //   src={selectedImage || NoImageFound}
              //   alt="Document"
              //   onError={(e) => {
              //     e.target.onerror = null; // Prevent infinite loop
              //     e.target.src = NoImageFound;
              //   }}
              //   style={{
              //     width: "100%",
              //     maxHeight: "400px",
              //     objectFit: "contain",
              //     border: "1px solid #ccc",
              //     borderRadius: "8px",
              //   }}
              // />
              isPdf ? (
                <iframe
                  src={pdfUrl}
                  title="PDF Document"
                  style={{
                    width: "100%",
                    height: "400px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                  }}
                />
              ) : (
                <img
                  src={selectedImage}
                  alt="Document"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = NoImageFound;
                  }}
                  style={{
                    width: "100%",
                    maxHeight: "400px",
                    objectFit: "contain",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                  }}
                />
              )
            ) : (
              <div>No document to display.</div>
            )}
          </div>
          <hr />
        </Box>
      </Modal>
    </>
  );
}
